import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, filter, map, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import * as CustomConfigurationActions from './custom-configuration.actions';
import {CustomConfigurationClientService} from './custom-configuration-client.service';
import {Store} from '@ngrx/store';
import {selectUserName} from '../user/user.reducer';
import {errorHappened} from '../app.types';


@Injectable()
export class CustomConfigurationEffects {

  loadCustomConfigurations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomConfigurationActions.loadCustomConfigurations),
      withLatestFrom(this.store.select(selectUserName)),
      filter(([_, username]) => username !== undefined),
      concatMap(([_, username]) =>
        this.client.fetch(username)
          .pipe(
            map(data => CustomConfigurationActions.loadCustomConfigurationsSuccess({config: data})))),
      catchError(error => of(errorHappened({error: {message: error.error}}))));
  });

  saveCustomConfiguration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomConfigurationActions.saveCustomConfiguration),
      withLatestFrom(this.store.select(selectUserName)),
      filter(([, username]) => username !== undefined),
      concatMap(([toSave, username]) =>
        this.client.save(username, toSave.config)
          .pipe(
            map(data => CustomConfigurationActions.saveCustomConfigurationSuccess({config: data})))),
      catchError(error => of(errorHappened({error: {message: error.error}}))));
  });


  constructor(private actions$: Actions,
              private store: Store,
              private client: CustomConfigurationClientService) {
  }
}
